export default __webpack_public_path__ + "static/media/twitter-gold.676ec504.png";